/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RankListItemMessage } from '../../models/rank-list-item-message';

export interface GetAllTimeRecords$Params {
  nameSpace: string;
}

export function getAllTimeRecords(http: HttpClient, rootUrl: string, params: GetAllTimeRecords$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RankListItemMessage>>> {
  const rb = new RequestBuilder(rootUrl, getAllTimeRecords.PATH, 'get');
  if (params) {
    rb.path('nameSpace', params.nameSpace, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RankListItemMessage>>;
    })
  );
}

getAllTimeRecords.PATH = '/api/namespaces/{nameSpace}/alltimerecords';
